import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'bpc-stripe-cancel-modal',
  components: {},
})
export default class StripeCancelModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: String, default: 'global.stripe_cancel_payment' }) readonly modalTitle: string;
  @Prop({ type: String, default: null }) readonly paymentIntentId: string;

  blockBtnClose: boolean = true;
  canceling: boolean = true;
  showAlert: boolean = false;
  alertVariant: string = 'null';
  alertMessage: string = '';
  stripeCanceledData: object = {};

  get stripeActivated() {
    return this.$store.getters['centerSettings/stripeActivated'];
  }

  get cancelPaymentIntentUrl() {
    return `${this.$bpcApiRouteHelper.getEntityPath('payment')}/stripe/cancel-payment-intent`;
  }

  mounted() {
    if (!this.stripeActivated) {
      this.showAlertMessage('danger', 'global.stripe_is_not_active');
    } else {
      const paymentData = {
        paymentIntentId: this.paymentIntentId,
      };
      this.$bpcApi.post(this.cancelPaymentIntentUrl, paymentData, {}, 'public').subscribe(
        res => {
          this.stripeCanceledData = res.data;
          this.canceling = false;
          this.blockBtnClose = false;
          this.showAlertMessage('success', 'global.stripe_payment_canceled');
        },
        error => {
          this.canceling = false;
          this.blockBtnClose = false;
          this.showAlertMessage('danger', 'global.stripe_payment_not_canceled');
        },
      );
    }
  }

  showAlertMessage(variant, message) {
    this.alertVariant = variant;
    this.alertMessage = message;
    this.showAlert = true;
  }

  hideAlertMessage() {
    this.alertVariant = 'null';
    this.alertMessage = '';
    this.showAlert = false;
  }

  close() {
    this.$emit('click-on-close');
    this.hideAlertMessage();
    this.$emit('result-cancellation', this.stripeCanceledData);
  }
}
